/* eslint-disable */

import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as relatorioActions from '../../actions/relatorioActions'
import GrafBarraTempoRespostaFaixa from './GrafBarraTempoRespostaFaixa'
import $ from 'jquery';



class TempoRespostaFaixaGrafBarra extends React.Component {

    constructor(props, context) {
        super(props, context);
        

        this.state = {
            pesquisando: true
        };
        this.getFaixa = this.getFaixa.bind(this);
    }

   componentDidMount() {
       
        if(!$.isEmptyObject(this.props.parametrosPesquisaRelatorio)){
            

            this.setState({ pesquisando: true });
            this.props.actions.ListarTempoRespostaPorFaixa(this.props.parametrosPesquisaRelatorio, this.props.tipicasOuvidoria).then(
                () => {
                    this.setState({ pesquisando: false });
                }).catch(error =>{
                this.alerta('Erro em relatório', error , 'error', 'tc');
            });
            //console.log(' componentDidMount - ListarTempoRespostaPorFaixa ', this.props.parametrosPesquisaRelatorio);
        }
    }
    alerta(titulo, mensagem, tipo, posicao){
        
        // this.props.actionsAlerta.apresentarAlerta({
        //     title: titulo!==null?titulo:'Aviso!',
        //     message: mensagem!==null?mensagem:'',
        //     level: tipo!==null?tipo:'error',
        //     position: posicao!==null?posicao:'tc',
        //     showMsg: true,
        //     autoDismiss:25
        // });
    }

    getFaixa(obj) {
       
        this.props.obtemFaixaSelecionada(obj)
    }


    componentWillReceiveProps(nextProps) {
        ;
        if(!$.isEmptyObject(nextProps.parametrosPesquisaRelatorio)){
            
          if(this.props.parametrosPesquisaRelatorio !== nextProps.parametrosPesquisaRelatorio ){
              //this.setState({ pesquisando: true }); 
              this.props.actions.ListarTempoRespostaPorFaixa(nextProps.parametrosPesquisaRelatorio, nextProps.tipicasOuvidoria).then(
                  () => {
                      this.setState({ pesquisando: false });
                  }).catch(error =>{
                    this.alerta('Erro em relatório', error , 'error', 'tc');
                });
                //console.log(' pesquisou - ListarTempoRespostaPorFaixa table ', nextProps.parametrosPesquisaRelatorio);
          }
        //   else{
        //     
        //     this.setState({ pesquisando: true });
        //     if(this.props.tipicasOuvidoria !== nextProps.tipicasOuvidoria){
        //         this.props.actions.ListarTempoRespostaPorFaixa(nextProps.parametrosPesquisaRelatorio, nextProps.tipicasOuvidoria).then(
        //             () => {
        //                 this.setState({ pesquisando: false });
        //             }).catch(error =>{
        //             this.alerta('Erro em relatório', error , 'error', 'tc');
        //         });
        //     }
        //   }
        }
        // if(!$.isEmptyObject(nextProps.relatorio)){
        //     if (this.props.relatorio !== nextProps.relatorio) {
        //         
        //         this.props.relatorioTempoRespostaPorFaixa(nextProps.relatorio);          
        //     }
        // }

    }
    render() {
        
        if ($.isEmptyObject(this.props.relatorio)) {
            return <div className='row loading'> <div className="col-lg-12 col-md-12 col-xs-12"><div className="dots-loader">Pesquisando...</div></div></div>
        }

     if(this.props.relatorio.dado===null){
       return <div className='col-centered'><h4>Não existem manifestações neste período.</h4></div>
     }

    
     return (
        <div>
            <GrafBarraTempoRespostaFaixa relatorio={this.props.relatorio} obtemFaixaSelecionada={this.getFaixa}   />
        </div>
        
    );
  }
}
TempoRespostaFaixaGrafBarra.protoType = {
    actions: PropTypes.object.isRequired,
    relatorioTempoRespostaPorFaixa: PropTypes.func.isRequired
}

function mapStateToProps(state, ownProps){
    
    return {
            relatorio: state.relatorioTempoRespostaFaixa
    };
}

function mapDispatchToProps(dispatch){
    return {
        actions: bindActionCreators(relatorioActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TempoRespostaFaixaGrafBarra);


/** WEBPACK FOOTER **
 ** ./src/components/relatorios/TempoResposta/TempoRespostaFaixaGrafBarra.js
 **/